import { StageManager } from './modules/registrations/stage-manager';
import { RegistrationApp } from './modules/registrations/app';

console.log(ajax_obj);
const DEFAULTS = JSON.parse(ajax_obj.default_settings);

document.addEventListener('alpine:init', () => {
    console.log('alpine init handler running');
    Alpine.store('status', {
        'current_delegate': -1,
        'defaults': DEFAULTS,
        'delegates': [],
        'sm': null,
        
        init() {
            console.log(this);
            
            this.delegates.push(structuredClone(DEFAULTS));
            
            this.setCurrentDelegate(this.firstDelegateExcluding(-1));
            
            console.log(this);
            
            this.sm = new StageManager;
        },
        finishAndPay() {
            let this_store = this;
            const data = new FormData();
            data.append('_ajax_nonce', ajax_obj.nonce);
            data.append('registration', JSON.stringify(this.delegates));
            data.append('action', 'add_registration_to_cart');
            data.append('event_id', ajax_obj.event_id);
            
            console.log('finish and pay', ajax_obj, data, this_store);
            
            axios.post(ajax_obj.ajax_url, data).then(function(response) {
                console.log(response);
                
                // if response is successful, redirect to cart, which we hope is provided by server, but will assume is /cart if not
                let redirect = response.data.data.redirect;
                if (redirect.length > 0 && typeof redirect !== 'undefined' && redirect !== 'undefined') {
                    window.location.assign(redirect);
                } else {
                    window.location.assign('/cart');
                }
            }).catch(function(error) {
                console.log(error);
            });
        },
        newDelegate() {
            let newDelegate = structuredClone(DEFAULTS);
            
            this.delegates.push(newDelegate);
            
            this.setCurrentDelegate(this.delegates.length - 1);
            
            this.setCurrentStage(this.currentStage());
        },
        currentStage() {
            return this.delegates[this.current_delegate].current_stage
        },
        setCurrentStage(newStageIndex) {
            this.delegates[this.current_delegate].current_stage = newStageIndex;
        },
        setCurrentDelegate(delegate_id) {
            this.current_delegate = delegate_id;
        },
        currentDelegate() {
            return this.delegates[this.current_delegate];
        },
        addDelegate(newDelegate) {
            this.delegates.push(newDelegate);
        },
        removeDelegate(delegate_id) {
            if (delegate_id < this.current_delegate) {
                this.setCurrentDelegate(Number(this.current_delegate) - 1);
            }
            if (delegate_id == this.current_delegate) {
                this.setCurrentDelegate(0);
            }
            delete this.delegates[delegate_id];
            this.delegates = this.delegates.filter((val) => true);
        },
        hasDelegates() {
            return this.delegates.length > 0;
        },
        firstDelegateExcluding(excluded) {
            for (let i = 0; i < this.delegates.length; i++) {
                console.log(i, excluded, i === excluded);
                if (i === excluded) {
                    continue;
                }
                
                return i;
            }
            
            return false;
        },
        delegateComplete(delegate_id) {
            for (let property in this.delegates[delegate_id].stage_statuses) {
                if (this.delegates[delegate_id].stage_statuses[property] === 'incomplete') {
                    return 'false';
                }
            }
            return 'true';
        },
        allDelegatesComplete() {
            for (let delegate_id in this.delegates) {
                if (this.delegateComplete(delegate_id) == 'false') {
                    return false;
                }
            }
            
            return true;
        },
        delegateTotal(delegate_id) {
            let total = 0;
            for (let product_id_str of this.delegates[delegate_id].registration_options) {
                total = total + Number(Alpine.store('products')[Number(product_id_str)].price);
            }
            return total;
        },
        allDelegatesTotal() {
            let total = 0;
            for (let delegate_id in this.delegates) {
                total = total + Number(this.delegateTotal(delegate_id));
            }
            return total;
        },
        validateDelegate(delegate) {
            this.validateCurrentStage();
        },
        validateCurrentStage() {
            this.currentDelegate().stage_statuses[this.currentStage()] = this.sm.validate(this.currentStage()) ? 'complete' : 'incomplete';
        },
        toggleRegistrationOption(product_id) {
            if (this.hasRegistrationOption(product_id)) {
                this.removeRegistrationOption(product_id);
            } else {
                this.addRegistrationOption(product_id);
            }
        },
        addRegistrationOption(product_id) {
            if (!this.hasRegistrationOption(product_id)) {
                this.currentDelegate().registration_options.push(String(product_id));
            }
        },
        removeRegistrationOption(product_id) {
            if (this.hasRegistrationOption(product_id)) {
                this.currentDelegate().registration_options.splice(this.currentDelegate().registration_options.indexOf(String(product_id)), 1);
            }
        },
        hasRegistrationOption(product_id) {
            return this.currentDelegate().registration_options.includes(String(product_id));
        },
        visaSupport() {
            let visaproduct = this.visaProduct();
            if (this.currentDelegate().visa_status.visa_assistance_required === 'yesvisasupport') {
                this.addRegistrationOption(visaproduct[0]);
            } else {
                this.removeRegistrationOption(visaproduct[0]);
            }
        },
        visaProduct() {
            return Object.entries(Alpine.store('products')).filter(([id, product]) => product.visa_support_product === true)[0];
        }
    });
    
    Alpine.store('products', ajax_obj.productData);
    console.log(ajax_obj.productData, Alpine.store('products'));
});